import { useText } from './loaders';
import { PreviewError, PreviewStatus } from './preview-state';

export function TextArtifactPreview({ sourceUrl, title }: { sourceUrl: string; title: string }) {
  const { data, error, loading } = useText(sourceUrl);

  if (loading) return <PreviewStatus>Loading {title}...</PreviewStatus>;
  if (error) return <PreviewError message={error.message} />;

  return (
    <pre className="min-h-full bg-white p-4 font-mono text-xs leading-5 break-words whitespace-pre-wrap">{data}</pre>
  );
}
